
import gql from 'graphql-tag'
import userFavProductMedical from '@/apollo/queries/user/userFavProductMedical'
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment'
import medicalTooltips from '~/apollo/queries/product/tooltips/medicalTooltips'
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: "FavProductMedical",
  mixins: [productPromotionMixins, productInsuranceNameMixins],
  data: () => ({
    product: Object,
    productLoading: 0,
    currentLink: "",
  }),
  props: {
    productId: String,
    params: String,
    favProductId: String,
  },
  apollo: {
    product: {
      prefetch: true,
      loadingKey: "productLoading",
      query: gql`${userFavProductMedical} ${productPromotionFragment}`,
      variables() {
        const returnObj = {};

        returnObj.id = this.productId;
        returnObj.locale = this.$normalizeLocale(this.$i18n.locale);
        returnObj.age = parseInt(this.simpleParams.age);
        returnObj.endAge = parseInt(this.simpleParams.age) + 9;

        console.debug(returnObj);

        return returnObj;
      },
      update(data) {
        return data?.medicalPlanScenarios?.data;
      },
      result({ data }) {
        // console.debug(JSON.stringify(data));
      },
    },
    tooltips: {
      query: medicalTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data).Medical;
      },
    },
  },
  computed: {
    simpleItem() {
      if (!this.productLoading) {
        if (this.product) {
          return this.product.map((item) => {
            let promotionPrices = Array;
            promotionPrices = [];

            let discountedTenYearAvgPremium = null;
            const age = parseInt(this.simpleParams.age);
            let promotions = null;
            let promotion = null;
            let promotionLastCall = null;

            let decoderCTALink = '';
            let mainCTA = this.getDecoderCTA(item, decoderCTALink);

            // check scenario level promo first , then plan level promotion 
            if (item.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.product_promotions.data;
            }
            if (item.attributes.medical_plan.data.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.medical_plan.data.attributes.product_promotions.data;
            }
            
            if(promotions != null) {
              promotion = this.checkPromotionValid(promotions);
              promotionLastCall = this.checkPromotionLastCall(promotion);

              if (!promotion) {
                promotion = null;
              }
              else {
                if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                  decoderCTALink =
                    promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                }
                
                mainCTA = this.getDecoderCTA(item, decoderCTALink, promotion);

                const discounts = promotion.attributes.DiscountPercentage;
                if (discounts) {
                  // calculate promotion price and avg premium
                  let tenYearPremium = 0;
                  const premium = item.attributes.premium_details_in_ten_years;

                  const premiumArray = this.getPremium(premium, age);

                  // console.debug(premiumArray);

                  premiumArray.forEach((premium) => {
                    const i = premium.age - age;
                    if (discounts['Year' + parseInt(i + 1)] === 0) {
                      promotionPrices[i] = null;
                      tenYearPremium += premium.value;
                    }
                    else {
                      const calculatedPrice = (premium.value * (100 - discounts['Year' + parseInt(i + 1)])) / 100;
                      promotionPrices[i] = parseInt(calculatedPrice.toFixed(0));
                      tenYearPremium += calculatedPrice;
                    }
                  });
                  discountedTenYearAvgPremium = parseInt((tenYearPremium / premiumArray.length).toFixed(0));
                }
              }
            }


            const fyp = item.attributes.medical_plan_premium_details.data[0].attributes.fyp;
            const averagePremium = item.attributes.medical_plan_premium_details.data[0].attributes.average_premium;

            if (discountedTenYearAvgPremium === parseInt(averagePremium.toFixed(0))) {
              discountedTenYearAvgPremium = null;
            }

            const filteredTranslations = this.getFilteredTranslations(item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
            .insurance_company_translations.data[0].attributes.localizations.data);

            return {
              scenario_code: item.attributes.scenario_code,
              currency: item.attributes.medical_plan.data.attributes.currency.data.attributes.code,

              // // plan
              plan_code: item.attributes.medical_plan.data.attributes.plan_code,
              medical_coverage_score: item.attributes.medical_plan.data.attributes.medical_coverage_score,
              medical_coverage: item.attributes.medical_plan.data.attributes.medical_coverage,
              overall_score: item.attributes.medical_plan.data.attributes.overall_score,
              overall_star: item.attributes.medical_plan.data.attributes.overall_star,
              special_feature_score: item.attributes.medical_plan.data.attributes.special_feature_score,
              plan_name: item.attributes.medical_plan.data.attributes.medical_plan_translations.data[0].attributes.name,

              // feature
              room: item.attributes.medical_plan.data.attributes.medical_room.data.attributes.medical_room_translations
                .data[0].attributes.name,
              geo_region:
                item.attributes.medical_plan.data.attributes.medical_geo_region.data.attributes
                  .medical_geo_region_translations.data[0].attributes.name,
              vhis_type:
                item.attributes.medical_plan.data.attributes.medical_vhis_type.data.attributes
                  .medical_vhis_type_translations.data[0].attributes.name,
              deductible: item.attributes.medical_plan.data.attributes.deductible,

              additional_features: item.attributes.medical_plan.data.attributes.additional_features,
              // medical_inflation_protection: item.attributes.medical_plan.data.attributes.medical_inflation_protection,

              // // insurer
              insurer_name_first:
                item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                  .insurance_company_translations.data[0].attributes.name,
              insurer_name_second:
                filteredTranslations[0].attributes.name,
              insurer_logo:
                item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                  .logo,
              insurer_code:
                item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                  .code,
              scenarioID: item.id,

              // premium
              //  price: item.attributes.medical_plan_premium_details.data[0].attributes.price,
              fyp,
              average_premium: averagePremium,

              // premium
              product_promotion: promotion,
              promotion_prices: promotionPrices,
              promotion_last_call: promotionLastCall,

              discounted_ten_year_avg_premium: discountedTenYearAvgPremium,

              main_cta: mainCTA
            };
          })[0];
        }
      }
      return null;
    },

    displayProduct() {
      if (this.simpleItem) {
        return {
          favProductId: this.favProductId,
          scenarioId: this.simpleItem.scenarioID,
          id: this.simpleItem.scenario_code,
          productType: "medical",
          showFiveStarBadge: this.$formatShowFiveStarBadge(this.simpleItem.overall_star),
          showTrending: false,
          productLink: this.$extendPath(
            '/products/medical',
            '/' + this.simpleItem.scenario_code + '?' + this.params
          ),
          productName: this.simpleItem.plan_name,
          insuranceCompany: {
            name: this.simpleItem.insurer_name_first + ' | ' + this.simpleItem.insurer_name_second,
            code: this.simpleItem.insurer_code,
            logoSrc: this.simpleItem.insurer_logo?.data?.attributes.url,
            logoAlt: this.simpleItem.insurer_name_first,
          },
          userRating: {
            score: this.simpleItem.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.getScore(this.simpleItem)),
            description: this.$t('products.medical.md_overall_score'),
            toolTipHtml: this.getTooltipContentByKey('md_overall_score'),
          },
          features: [
            {
              text: this.simpleItem.room,
              type: 'room_type',
            },
            {
              text: this.simpleItem.geo_region,
              type: 'geographical_coverage',
            },
            {
              text: this.simpleItem.vhis_type,
              type: 'plan_type',
            },
            {
              text: this.$formatPrice(this.simpleItem.deductible) + ' ' + this.$t('products.medical.md_deductible'),
              type: 'deductible',
            },
          ],
          keyItems: [
            {
              value: this.$formatScore(this.simpleItem.medical_coverage_score) + ' / 10',
              key: this.$t('products.medical.md_medicalCoverageScore'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('md_medicalCoverageScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(this.simpleItem.special_feature_score) + ' / 10',
              key: this.$t('products.medical.md_special_feature_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('md_special_feature_score'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.simpleItem.discounted_ten_year_avg_premium
                ? this.simpleItem.discounted_ten_year_avg_premium.toLocaleString('en-US')
                : parseInt(this.simpleItem.average_premium.toFixed(0)).toLocaleString('en-US'),
              key: this.$t('products.medical.md_10_yearAvgPremium'),
              topSubText: this.simpleItem.currency,
              toolTipHtml: this.get10YearAveragePremiumTooltip(),
              symbolValue: '',
              originalValue: this.simpleItem.discounted_ten_year_avg_premium
                ? parseInt(this.simpleItem.average_premium.toFixed(0)).toLocaleString('en-US')
                : '',
            },
          ],
          compactKeyItems: [
            {
              value: this.$formatScore(this.simpleItem.medical_coverage_score) + ' / 10',
              key: this.$t('products.medical.md_medicalCoverageScore'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('md_medicalCoverageScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(this.simpleItem.special_feature_score) + ' / 10',
              key: this.$t('products.medical.md_special_feature_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('md_special_feature_score'),
              symbolValue: '',
              originalValue: '',
            },
          ],
          promotion: {
            category:
              this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
            title:
              this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink:
              this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText:
              this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: this.simpleItem.product_promotion?.id,
            scenarioId: this.simpleItem.scenarioID,
            lastCall: this.simpleItem.promotion_last_call

          },
          mainButtonCTA: this.simpleItem.main_cta, 
          price: {
            originalPrice: this.simpleItem.promotion_prices[0] ? parseInt(this.simpleItem.fyp.toFixed(0)).toLocaleString('en-US') : '',
            discountPrice: this.simpleItem.promotion_prices[0]
              ? parseInt(this.simpleItem.promotion_prices[0]).toLocaleString('en-US')
              : parseInt(this.simpleItem.fyp.toFixed(0)).toLocaleString('en-US'),
            prefix: this.simpleItem.currency,
            postfix: '',
            subText: this.$t('products.medical.md_firstYearPremium'),
            toolTipHtml: this.getFirstYearPremiumTooltip(),
          },
        }
      }
      return null;
    },

    simpleParams() {
      let vars = Array;
      vars = [];
      const hash = this.params.split('&');

      for (let i = 0; i < hash.length; i++) {
        const params = hash[i].split("=");
        vars[params[0]] = params[1];
      }

      return vars;
    }
  },
  watch: {
    product() {
      if (this.product.length) {
        this.$emit("product-load", 'Medical');
      } else {
        try {
          throw new Error("*** Product not found ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
    },
  },
  mounted() {
    this.currentLink = window.location.href;
  },
  updated() {
    if (this.simpleItem) {
      this.$emit("productTitle", { id: this.favProductId, companyName: this.simpleItem.insurer_name_first, title: this.simpleItem.plan_name });
    }
  },
  methods: {

    getScore(product) {
      return product.overall_score?.toFixed(1);
    },

    getPremium(premium, startAge) {
      const endAge = startAge + 9;
      const selectedAge = () => {
        return premium.data.filter((agePremium) => {
          return agePremium.attributes.age >= startAge && agePremium.attributes.age <= endAge;
        });
      };

      return selectedAge().map((agePremium) => ({
        age: agePremium.attributes.age,
        value: agePremium.attributes.price,
      }));
    },

    getTooltipContentByKey(mKey) {
      return this.tooltips?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getFirstYearPremiumTooltip() {
      const tooltip = this.getTooltipContentByKey('md_firstYearPremium');
      return tooltip
        .replace('{replace_age}', this.simpleParams.age.toString())
        .replace('{replace_gender}', this.simpleParams.gender.toString() === '1' ? this.$t('products.male') : this.$t('products.female'),);
    },

    get10YearAveragePremiumTooltip() {
      const tooltip = this.getTooltipContentByKey('md_10_yearAvgPremium');
      return tooltip
        .replace('{replace_gender}', this.simpleParams.gender.toString() === '1' ? this.$t('products.male') : this.$t('products.female'),)
        .replace('{replace_age_from}', this.simpleParams.age.toString())
        .replace('{replace_age_to}', (parseInt(this.simpleParams.age) + 9).toString());
    },

    getDecoderCTA(item, promotionCTALink, promotion = null) {
      const planName = item.attributes.medical_plan.data.attributes.medical_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const link = this.currentLink;
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.medical.md_categoryName'), insurer, planName, { page: this.$route.name?.split('__')[0], link: link });
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.medical_plan.data.attributes.saleable;
      const productWebsite = item.attributes.medical_plan.data.attributes.medical_plan_translations.data[0].attributes.product_website;
      const salesLink = process.env.SALES_EXTERNAL_URL + '/' + (this.currentLocale === 'en' ? 'en' : 'tc') + '/purchase?type=vhis&id=' + item.attributes.scenario_code + (promotion?.id ? '&promotionId=' + promotion?.id : '');

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link: salesLink,
          popupData: {
            applicationLink: salesLink,
            whatsappLink: decoderCTAWhatsappLink
          },
          type: 'popup'
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.product_website'),
          link: promotionCTALink,
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website',
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink,
        };
      }
    },

    unfavourite() {
      this.$emit("unfavourite", this.favProductId)
    },
  },
}
